import yup from "src/validators/yup.Module";

export type FormType = yup.InferType<typeof schema>;

export const schema = yup.object({
  dadosParcelas: yup.array().of(
    yup.object({
      meioPagamento: yup
        .number()
        .typeError("Selecione o meio de pagamento")
        .required("Selecione o meio de pagamento"),

      valorPagamento: yup
        .number()
        .required("Informe o valor")
        .typeError("Informe o valor válido")
        .when("meioPagamento", {
          is: (meioPagamento: number) => meioPagamento === 90,
          then: (schema) =>
            schema.test(
              "valor-zero",
              "Sem meio pagamento, informe zero",
              (value) => value === 0
            ),
          otherwise: (schema) =>
            schema
              .required("Informe o valor")
              .moreThan(0, "Valor deve ser maior que zero"),
        }),

      tipoIntegracao: yup
        .number()
        .nullable()
        .when("meioPagamento", {
          is: (meioPagamento: number) =>
            meioPagamento === 3 || meioPagamento === 4,
          then: (schema) =>
            schema.required(
              "Tipo de integração é obrigatório para este meio de pagamento"
            ),
          otherwise: (schema) => schema.notRequired().nullable(),
        }),

      descricaoMeioPagamento: yup
        .string()
        .nullable()
        .when("meioPagamento", {
          is: (meioPagamento: number) => meioPagamento === 99,
          then: (schema) =>
            schema.required("Descrição é obrigatório para pagamento 'outros'"),
          otherwise: (schema) => schema.notRequired().nullable(),
        }),
    })
  ),
  totalPagamentos: yup.string(),
  diferencaPagamentos: yup.string(),
});
